<template>
  <v-text-field
    ref="textFieldRef"
    class="customInput"
    variant="solo"
    v-model="inputValue"
    @input="onInput"
    :label="label ? $t(label) : label"
    :placeholder="placeholder ? $t(placeholder) : placeholder"
  />
</template>

<script>
  export default {
    name: 'Input',
    props: {
      modelValue: {
        type: String,
        default: null,
      },
      onlyNumber: {
        type: Boolean,
        default: false,
      },
      label: String,
      placeholder: String
    },
    computed: {
      inputValue: {
        get() {
          return this.modelValue;
        },
        set(value) {
          if (this.onlyNumber) {
            if (!this.isNumber(value) && value) {
              return;
            }
            if (!value) {
              value = null
            }
          }
          this.$emit('update:modelValue', value);
        }
      }
    },
    methods: {
      validate () {
        this.$refs.textFieldRef.validate();
      },
      /**
       * Проверить является ли переданное значение числом
       * @param value
       */
      isNumber(value) {
        return /^\d+$/.test(value);
      },
      /**
       * Событие, срабатывающее после обновления модели
       */
      onInput(e) {
        if (this.onlyNumber) {
          e.target.value = e.target.value.replace(/[^0-9]/g, '');
        }
      }
    }
  };
</script>

<style scoped>
  /* Варианты текстового поля */
  .customInput :deep(.v-field--variant-solo) {
    --v-field-padding-start: 12px;
    --v-field-padding-end: 12px;
    border: 1px solid rgb(var(--blue-blue-secondary-hover));
    border-radius: 8px;
    box-shadow: none;
  }

  .customInput :deep(.v-field--variant-underlined) {
    pointer-events: none;
  }

  /* Состояния текстового поля */
  .customInput :deep(.v-field:hover) {
    border-color: rgb(var(--grey-1));
  }

  .customInput :deep(.v-field:focus-within) {
    border-color: rgb(var(--grey-5));
  }

  .customInput :deep(.v-field--disabled) {
    background-color: rgb(var(--disabled-grey));
    opacity: 1;
  }

  /* Лейбл текстового поля */
  .customInput :deep(.v-label) {
    font-family: 'Manrope';
    font-weight: 500;
    opacity: 1;
  }

  .customInput :deep(.v-label.v-field-label) {
    font-size: 16px;
    color: rgb(var(--grey-1));
  }

  .customInput :deep(.v-label.v-field-label--floating) {
    font-size: 10px;
    color: rgb(var(--grey-1));
  }

  .customInput :deep(.v-field--dirty .v-label.v-field-label--floating) {
    color: rgb(var(--grey-5)) !important;
  }

  /* Текст внутри текстового поля */
  .customInput :deep(.v-field__input) {
    font-family: 'Manrope';
    font-weight: 500;
    font-size: 14px;
    color: rgb(var(--grey-5));
  }

  /* Ошибка в текстовом поле */
  .customInput :deep(.v-field--error) {
    border-color: rgb(var(--error-color)) !important;
  }

  .customInput :deep(.v-input__details) {
    padding-inline: 0px;
  }

  .customInput :deep(.v-messages__message) {
    font-family: 'Manrope';
    font-weight: 500;
    font-size: 14px;
    color: rgb(var(--error-color));
    margin-bottom: 10px;
  }

  .customInput :deep(.v-field--error:not(.v-field--disabled) .v-label.v-field-label,
    .v-field--error:not(.v-field--disabled) .v-field-label--floating) {
    color: rgb(var(--grey-1));
  }

  /* Обязательное текстовое поле (см. на атрибут required) */
  .customInput :deep(.v-field__field:has(.v-field__input[required]) .v-label::after) {
    content: ' *';
    color: rgba(var(--error-color));
  }

  .disabled :deep(.v-field) {
    background-color: rgb(var(--disabled-grey));
    pointer-events: none;
    transition: background-color 0.5s ease;
  }
</style>
